"use client";
import { GridProps, SimpleGrid, Stack } from "@chakra-ui/react";
import type { ResponsiveValue } from "@chakra-ui/styled-system";
import { Balancer } from "react-wrap-balancer";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import Card, { CardProps } from "./card";

type Props = {
  columns?: ResponsiveValue<number>;
  desc?: string;
  list: CardProps[];
  spacing?: GridProps["gridGap"];
  title?: string;
  hoverEffect?: boolean;
  hover?: Record<string, any>;
};

const CardsList = (props: Props) => {
  const {
    columns = { base: 1, sm: 2, md: 4 },
    desc,
    list,
    spacing = { base: 8, md: 12, "2xl": 16 },
    title,
    hoverEffect = false,
    hover,
  } = props;
  const headingVariant = useHeadingVariant();

  return (
    <Stack gap={8}>
      <Stack gap={6}>
        {title && (
          <Heading as="h3" variant={headingVariant} textAlign={"center"}>
            {title}
          </Heading>
        )}
        <Balancer>
          {desc && (
            <Text variant={"label1"} color={"text.100"} textAlign={"center"}>
              {desc}
            </Text>
          )}
        </Balancer>
      </Stack>
      <SimpleGrid columns={columns} gap={spacing}>
        {list.map((item, index) => (
          <Card key={index} {...item} hoverEffect={hoverEffect} hover={hover} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default CardsList;
